class PetDisclaimerModal extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector("dialog");
    this.modal.addEventListener("close", this.enablePageScrolling);
    this.showModal();
    this.querySelectorAll("[data-close-disclaimer]").forEach((element) => {
      element.addEventListener("click", this.closeModal);
    });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.modal.showModal();
      }
    });
  }

  showModal = () => {
    this.modal.showModal();
    this.disablePageScrolling();
  };

  closeModal = () => {
    this.modal.close();
    this.enablePageScrolling();
  };

  disablePageScrolling = () => {
    document.querySelector("body").style.overflow = "hidden";
  };

  enablePageScrolling = () => {
    document.querySelector("body").style.overflow = "";
  };
}

window.customElements.define("pet-disclaimer-modal", PetDisclaimerModal);
